import React, { useEffect, useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import TextBlock from '../TextBlock/TextBlock';
import * as styles from './banner.module.scss';
import Img from "gatsby-image"

export const Banner = ({ data }) => {
  let containerSize = 'md';
  if (data.size === 'fullscreen') {
    containerSize = 'fs';
  }

  if (data.size === 'large') {
    containerSize = 'lg';
  }

  const { image, mobileImage, description } = data;
  return (
    <div className={styles[containerSize]}>
      <div className={`container container-${containerSize}`}>
        {image && (
          // <GatsbyImage
          //   className={`${styles.image} ${styles.imageDesktop}`}
          //   image={image.gatsbyImageData}
          //   alt={image.title}
          // />
          <Img fluid={image.fluid} alt={image.title} className={`${styles.image} ${styles.imageDesktop}`}/>
        )}
        {image && (
          // <GatsbyImage
          //   className={`${styles.image} ${styles.imageMobile}`}
          //   image={(mobileImage || image).gatsbyImageData}
          //   alt={(mobileImage || image).title}
          // />
          <Img fluid={mobileImage.fluid} alt={mobileImage.title} className={`${styles.image} ${styles.imageMobile}`}/>
        )}
        {description && (
          <div className= {styles.description}>
            <TextBlock
              data={description}
          />
          </div>
        )}
      </div>
    </div>
  );
}